export const WORKPOOL_PROPERTY_NAME = "workPool";
export const SOURCE_WAREHOUSE_ID_PROPERTY_NAME = "sourceWarehouseId";
export const SOURCE_WAREHOUSE_ID_OR_SCSC_CODE_PROPERTY_NAME = "sourceWarehouseIdOrSCACCode";
